<template>
    <v-card :color="pushNotification.color" dark :elevation="elevation">
        <v-card-text class="white--text">
            <v-row align="center">
                <v-col cols="auto" v-if="pushNotification.data.icon">
                    <v-icon large>{{ pushNotification.data.icon }}</v-icon>
                </v-col>
                <v-col>
                    <div class="text-subtitle-1 font-weight-bold" v-html="pushNotification.data.title"></div>
                    <div class="text-body-2" v-html="pushNotification.data.text"></div>
                </v-col>
                <v-col cols="auto" v-if="pushNotification.closable">
                    <v-btn @click="close" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import AbstractNotification from "@/components/General/PushNotification/AbstractNotification";

export default {
    extends: AbstractNotification,
}
</script>
